import React, { createContext, useContext, useState } from "react";

const ImportModalContext = createContext();

export const ImportModalProvider = ({ children }) => {
  const [showImportModal, setShowImportModal] = useState(false);

  return (
    <ImportModalContext.Provider
      value={{
        showImportModal,
        setShowImportModal,
      }}
    >
      {children}
    </ImportModalContext.Provider>
  );
};

export const useImportModal = () => useContext(ImportModalContext);
